import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './components/FirebaseAuth';

import PublicRouter from './components/routers/PublicRouter';
import PublicTemplate from './components/templates/PublicTemplate';
import AccountTemplate from './components/templates/AccountTemplate';

import AuthRouter from './components/routers/AuthRouter';

import SignIn from './pages/public/SignIn';
import SignUp from './pages/public/SignUp';
import ForgotPassword from './pages/public/ForgotPassword';
import Home from './pages/auth/Home';
import PageNotFound from './pages/public/PageNotFound';
import AppTemplate from './components/templates/AppTemplate';
import UserProfile from './pages/auth/user/UserProfile';
import UpdateEmail from './pages/auth/user/UpdateEmail';
import UpdateName from './pages/auth/user/UpdateName';
import VerifyEmail from './pages/auth/user/VerifyEmail';
import UpdatePassword from './pages/auth/user/UpdatePassword';
import UpdatePhone from './pages/auth/user/UpdatePhone';
import DeleteUser from './pages/auth/user/DeleteUser';
import ViewLogs from './pages/auth/user/ViewLogs';
import Plans from './pages/auth/accounts/Plans';
import NewAccount from './pages/auth/accounts/NewAccount';

import stripeJson from "./inc/stripe.json";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Overview from './pages/auth/accounts/Overview';
import UserList from './pages/auth/accounts/UserList';
import UserRole from './pages/auth/accounts/UserRole';
import AddUser from './pages/auth/accounts/AddUser';
import Invite from './pages/auth/user/Invite';
import PaymentList from './pages/auth/accounts/PaymentList';
import PaymentMethod from './pages/auth/accounts/PaymentMethod';
import DeleteAccount from './pages/auth/accounts/DeleteAccount';
import Settings from './pages/auth/accounts/Settings'
import Installation from './pages/auth/accounts/Installation';

const stripePromise = loadStripe(stripeJson.stripeConfig.public_api_key);

function App() {
	return (
		<Elements stripe={stripePromise}>
			<AuthProvider>
				<Router>
					<Routes>
						<Route path="/" element={<AuthRouter template={AppTemplate} title="My Projects"><Home /></AuthRouter>} />
						<Route path="/account/:accountId/billing/plan" element={<AuthRouter template={AccountTemplate} title="Select Plan" role="admin" allowInactive={true}><Plans /></AuthRouter>} />
						<Route path="/account/:accountId/billing/payment-method" element={<AuthRouter template={AccountTemplate} title="Update Payment Method" role="admin"><PaymentMethod /></AuthRouter>} />
						<Route path="/account/:accountId/billing/delete" element={<AuthRouter template={AccountTemplate} title="Delete Account" role="admin"><DeleteAccount /></AuthRouter>} />
						<Route path="/account/:accountId/users/change/:userId" element={<AuthRouter template={AccountTemplate} title="Change Role" role="admin"><UserRole /></AuthRouter>} />
						<Route path="/account/:accountId/users" element={<AuthRouter template={AccountTemplate} title="Users" role="admin"><UserList /></AuthRouter>} />
						<Route path="/account/:accountId/users/add" element={<AuthRouter template={AccountTemplate} title="Add User" role="admin"><AddUser /></AuthRouter>} />
						<Route path="/account/:accountId/billing" element={<AuthRouter template={AccountTemplate} title="Billing" role="admin"><PaymentList /></AuthRouter>} />
						<Route path="/account/:accountId/settings" element={<AuthRouter template={AccountTemplate} title="Project Settings" role="admin"><Settings /></AuthRouter>} />
						<Route path="/account/:accountId/installation" element={<AuthRouter template={AccountTemplate} title="Installation" role="*"><Installation /></AuthRouter>} />
						<Route path="/account/:accountId/" element={<AuthRouter template={AccountTemplate} title="Overview" role="*"><Overview /></AuthRouter>} />
						<Route path="/new-project" element={<AuthRouter template={AppTemplate} title="Create New Project"><NewAccount /></AuthRouter>} />
						<Route path="/user/profile" element={<AuthRouter template={AppTemplate} title="User Profile"><UserProfile /></AuthRouter>} />
						<Route path="/invite/:code" element={<AuthRouter template={AppTemplate} title="View Invite"><Invite /></AuthRouter>} />
						<Route path="/user/profile/update-email" element={<AuthRouter template={AppTemplate} title="Change Your Email"><UpdateEmail /></AuthRouter>} />
						<Route path="/user/profile/update-name" element={<AuthRouter template={AppTemplate} title="Change Your Name"><UpdateName /></AuthRouter>} />
						<Route path="/user/profile/verify-email" element={<AuthRouter template={AppTemplate} title="Verify Your Name"><VerifyEmail /></AuthRouter>} />
						<Route path="/user/profile/update-password" element={<AuthRouter template={AppTemplate} title="Change Your Password"><UpdatePassword /></AuthRouter>} />
						<Route path="/user/profile/update-phone" element={<AuthRouter template={AppTemplate} title="Change Your Phone Number"><UpdatePhone /></AuthRouter>} />
						<Route path="/user/profile/delete" element={<AuthRouter template={AppTemplate} title="Delete Your Account"><DeleteUser /></AuthRouter>} />
						<Route path="/user/log" element={<AuthRouter template={AppTemplate} title="View Activity Logs"><ViewLogs /></AuthRouter>} />
						<Route path="/signin" element={<SignIn />} />
						<Route path="/signup" element={<SignUp />} />
						<Route path="/forgot-password" element={<ForgotPassword />} />
						<Route path="*" element={<PublicRouter template={PublicTemplate} title="Page Not Found"><PageNotFound /></PublicRouter>} />
					</Routes>
				</Router>
			</AuthProvider>
		</Elements>
	);
}

export default App;
